import React from "react"
import {
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Slide,
  DialogContent,
  Paper,
  Typography,
  Divider,
  TableRow,
  TableContainer,
  TableCell,
  TableBody,
  Table,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const ActivePositionDialog = ({ handleClose, details, handleCancel, goToChat }) => {
  const { book, status, action } = details
  const { title, isBundle, grade, subject, priceOriginal, publisher, comment, isbn } = book

  return (
    <Dialog TransitionComponent={Transition} onClose={handleClose} open>
      <DialogTitle>
        {title}
        <IconButton sx={{ position: "absolute", right: "1vw", top: "1vh" }} onClick={handleClose}>
          <CloseIcon color="secondary" />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          overflow: "auto",
        }}>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              {/* <TableRow>
                <TableCell align="left">{action ? "Ich kaufe" : "Ich verkaufe"}</TableCell>
                <TableCell align="right" />
              </TableRow> */}
              <TableRow>
                <TableCell align="left">Klasse</TableCell>
                <TableCell align="right">{grade}</TableCell>
              </TableRow>
              {!isBundle && (
                <>
                  <TableRow>
                    <TableCell align="left">Fach</TableCell>
                    <TableCell align="right">{subject}</TableCell>
                  </TableRow>
                  {/* eslint-disable-next-line */}
                  {!!isbn && isbn != 0 ? (
                    <TableRow>
                      <TableCell align="left">ISBN</TableCell>
                      <TableCell align="right">{isbn}</TableCell>
                    </TableRow>
                  ) : (
                    <></>
                  )}
                  {publisher ? (
                    <TableRow>
                      <TableCell align="left">Verlag</TableCell>
                      <TableCell align="right">{publisher}</TableCell>
                    </TableRow>
                  ) : (
                    <></>
                  )}
                  {priceOriginal ? (
                    <TableRow>
                      <TableCell align="left">Originalpreis</TableCell>
                      <TableCell align="right">{priceOriginal} €</TableCell>
                    </TableRow>
                  ) : (
                    <></>
                  )}
                </>
              )}
              <TableRow>
                <TableCell align="left">Endgültiger Preis</TableCell>
                <TableCell align="right">Nach Absprache mit Partner</TableCell>
              </TableRow>
              {isBundle || comment ? (
                <TableRow>
                  <TableCell align="left">Information</TableCell>
                  <TableCell align="right">{isBundle ? `Alle Bücher der Klasse ${grade} zusammen.` : comment}</TableCell>
                </TableRow>
              ) : (
                <></>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {status === "matched" && (
          <Button variant="contained" onClick={goToChat} fullWidth sx={{ mt: 2 }}>
            Zum Chat
          </Button>
        )}

        <Button variant="contained" onClick={handleCancel} fullWidth sx={{ mt: 2, backgroundColor: "salmon" }}>
          {action === "buy" ? "Kauf" : "Verkauf"} abbrechen
        </Button>

        <Divider sx={{ mt: "3vh" }} />

        <Typography sx={{ mt: "1vh", color: "gray" }} variant="caption">
          Es wird lediglich ein Partner gesucht und ein engültiger Kauf / Verkauf ist nicht garantiert.
          <br /> Preis nach Absprache mit dem Partner.
        </Typography>
      </DialogContent>
    </Dialog>
  )
}

export default ActivePositionDialog
